var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed w-1/2 z-50 top-0 left-0 text-left pointer-events-none",attrs:{"id":"details"}},[_c('p',[_vm._v(_vm._s(_vm.project.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }